// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".block-digital-scene.-with-image:first-child{margin-top:-100px}.block-digital-scene.-with-image:first-child .g-container{padding-top:100px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
